import { useEffect, useState } from "react";
import { Quote } from "lucide-react";
import api from "../lib/api";
import { imgSrc } from "./LogoUpload";

export function usePublicTestimonials() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/public/testimonials").then((r) => setItems(r.data.items || [])).catch(() => {});
  }, []);
  return items;
}

export default function Testimonials({ limit, testid = "testimonials" }) {
  const all = usePublicTestimonials();
  const items = limit ? all.slice(0, limit) : all;
  if (!items.length) return null;
  return (
    <section className="pr-sec tm" data-testid={testid}>
      <div className="sec-head">
        <span className="eyebrow">Udtalelser</span>
        <h2>Det siger butikkerne</h2>
      </div>
      <div className={`tm-grid n${Math.min(items.length, 3)}`}>
        {items.map((t, i) => (
          <figure className="tm-card" key={i} data-testid={`${testid}-item-${i}`}>
            <Quote className="tm-q" size={22} aria-hidden="true" />
            <blockquote data-testid={`${testid}-quote-${i}`}>{t.quote}</blockquote>
            <figcaption>
              {t.logo_url ? <img src={imgSrc(t.logo_url)} alt="" loading="lazy" /> : <span className="tm-ini">{t.shop_name.slice(0, 1)}</span>}
              <span>
                <b>{t.person_name}{t.role ? `, ${t.role}` : ""}</b>
                <small>{t.shop_name}{t.city ? `, ${t.city}` : ""}</small>
              </span>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}
